import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
    resolveColorContext,
    type ContextFamily,
    type ContextTone,
} from '@quipex/shared/utils';

@Component({
    selector: 'qpx-loader',
    imports: [NgClass, MatProgressSpinnerModule],
    templateUrl: './loader.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'containerClass()',
    },
})
export class Loader {
    public readonly ariaLabel = input<string>('');
    public readonly ariaLabelledBy = input<string>('');
    public readonly inputClasses = input<string[]>([]);
    public readonly context = input<ContextFamily | undefined>('primary');
    public readonly tone = input<ContextTone>('default');
    protected readonly indicatorColor = computed(() => {
        const context = this.context();
        return context
            ? `var(${resolveColorContext(context, this.tone()).decorative.variable})`
            : 'currentColor';
    });
    public readonly containerClass = input(
        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[5]'
    );
    public readonly diameter = input<number>();
    public readonly size = input<'sm' | 'md' | 'lg'>('lg');

    protected readonly computedDiameter = computed(() => {
        const diameter = this.diameter();
        if (diameter) return diameter;

        switch (this.size()) {
            case 'sm':
                return 16;
            case 'md':
                return 24;
            case 'lg':
                return 40;
        }
    });
}
